export default () => {
  return {
    home: {
      width: '100%',
      maxHeight: '900px',
    },
    routeChildrenWrap: {
      width: '1200px',
      paddingTop: '21px',
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: '20px',
      margin: '64px auto 0',
    },
  }
}
